import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { LockKey, CheckCircle } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Field } from "@/components/common";
import { Brand } from "@/pages/Login";
import { api, errMsg } from "@/lib/api";

export default function AcceptInvitation() {
  const location = useLocation();
  const [token, setToken] = useState(() => new URLSearchParams(window.location.hash.slice(1)).get("token") || "");
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  useEffect(() => {
    const next = new URLSearchParams(location.hash.slice(1)).get("token");
    if (next && next !== token) {
      setToken(next); setUser(null); setLoading(true); setError(""); setDone(false); setPassword(""); setConfirm("");
    }
  }, [location.hash, token]);
  useEffect(() => {
    window.history.replaceState(null, "", window.location.pathname);
    let active = true;
    if (!token) { setError("Davet bağlantısı eksik. E-postanızdaki bağlantıyı açın veya yöneticinizden yeni davet isteyin."); setLoading(false); return; }
    api.post("/auth/invitations/inspect", { token }).then((r) => { if (active) setUser(r.data); })
      .catch((e) => { if (active) setError(errMsg(e)); }).finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [token]);
  const submit = async (e) => {
    e.preventDefault(); setError("");
    if (password !== confirm) return setError("Şifreler birbiriyle eşleşmiyor.");
    if (new TextEncoder().encode(password).length > 72) return setError("Şifreniz çok uzun; daha kısa bir şifre seçin.");
    setBusy(true);
    try { await api.post("/auth/invitations/accept", { token, password }); setPassword(""); setConfirm(""); setDone(true); }
    catch (e2) { setError(errMsg(e2)); }
    finally { setBusy(false); }
  };
  return <div className="flex min-h-screen flex-col items-center justify-center bg-[#0f2033] px-5 py-12" data-testid="accept-invitation-page">
    <Brand className="mb-8 text-4xl" />
    <div className="w-full max-w-md border-t-4 border-[#2dd4bf] bg-white p-7 sm:p-9">
      {done ? <div data-testid="invitation-success"><CheckCircle size={40} className="mb-4 text-teal-600" /><h1 className="font-display text-2xl font-bold">Hesabınız hazır</h1><p className="mt-3 text-sm text-muted-foreground">Şifreniz belirlendi. Artık e-posta adresiniz ve yeni şifrenizle giriş yapabilirsiniz.</p><Button asChild className="mt-6 w-full"><Link to="/login" data-testid="invitation-login-link">Giriş Yap</Link></Button></div> : <>
        <LockKey size={32} className="mb-4 text-teal-700" /><h1 className="font-display text-2xl font-bold">Şifrenizi belirleyin</h1>
        {loading && <p className="mt-4 text-sm" data-testid="invitation-loading">Davetiniz doğrulanıyor…</p>}
        {user && <><p className="mt-3 text-sm text-muted-foreground" data-testid="invitation-recipient">Hoş geldiniz, {user.name}<br /><strong className="break-all font-medium text-slate-700">{user.email}</strong></p>
          <form onSubmit={submit} className="mt-6 space-y-4" data-testid="invitation-password-form">
            <Field label="Yeni şifre"><Input type="password" autoComplete="new-password" minLength={8} maxLength={72} required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="invitation-password" /></Field>
            <Field label="Şifre tekrar"><Input type="password" autoComplete="new-password" minLength={8} maxLength={72} required value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="invitation-password-confirm" /></Field>
            <p className="text-xs text-muted-foreground">En az 8 karakter kullanın. Bu bağlantı tek kullanımlıktır.</p>
            <Button type="submit" disabled={busy} className="w-full" data-testid="invitation-submit">{busy ? "Kaydediliyor…" : "Şifremi Belirle"}</Button>
          </form></>}
        {error && <p role="alert" className="mt-4 border border-red-200 bg-red-50 p-3 text-sm text-red-700" data-testid="invitation-error">{error}</p>}
        <Link to="/login" className="mt-6 block text-sm text-teal-700 underline" data-testid="invitation-back-login">Giriş sayfasına dön</Link>
      </>}
    </div><p className="mt-6 text-xs text-slate-300">Bizim Cari · Güvenli hesap daveti</p>
  </div>;
}
